// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-sw-street-config__row',
    // #endregion
    // #region Properties
    props: {
        configuration: {
            type: Object,
            required: true,
            default: {}
        },
        record: {
            type: Object,
            required: true,
            default: {}
        },
    },
    data: () => ({
        _row: {
            text: '',
            text_length: 0,
            number: 1
        },
    }),
    watch: {
        '_row.text': function (val) {
            this._row.text_length = val.length;
        },
    },
    methods: {
        OnDelete() {
            //Record
            let tRecords = this.configuration.records;
            let tIndex = tRecords.indexOf(this.record);
            //Remove
            tRecords.splice(tIndex, 1);
            //Renumber
            let tNumber = 1;
            //Renumber
            tRecords.forEach((e) => {
                e.number = tNumber++;
            });
        }
    },
    // #endregion
});
// #endregion
